<template>
  <div class="base-dialog">
    <el-dialog
      :title="formList.title"
      :visible.sync="dialogFormVisible"
      @close="closeDialog"
    >
      <el-form :model="formList">
        <span class="red">*</span>
        <el-form-item :label="formList.nameKey" v-if="formList.type == 0">
          <el-input
            v-model="formList.nameValue"
            class="base-dialog-input"
            autocomplete="off"
            type="text"
            placeholder="不超过10个字的名称，多填写时不支持输入"
            maxlength="10"
            show-word-limit
          ></el-input>
        </el-form-item>

        <el-form-item :label="formList.nameKey" v-if="formList.type === 1">
          <el-input
            v-model="formList.nameValue"
            class="base-dialog-input"
            autocomplete="off"
            type="text"
            :placeholder="
              formList.inputPlaceholder ||
              '不超过10个字的名称，多填写时不支持输入'
            "
            maxlength="10"
            show-word-limit
          ></el-input>
        </el-form-item>
        <el-form-item :label="formList.belongInfo" v-if="formList.type === 1">
          <el-select
            class="base-dialog-select"
            placeholder="请选择"
            v-model="formList.business_ID"
            @change="changeSelectVal"
            :disabled="isDisabled"
          >
            <el-option
              v-for="item in businessList"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            >
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item
          :label="formList.contentDisclosure"
          v-if="formList.isShow"
        >
          <el-radio v-model="formList.publicity" label="1">公开</el-radio>
          <el-radio v-model="formList.publicity" label="2">私有</el-radio>
        </el-form-item>
        <el-form-item
          required
          :label="formList.showShareDesc"
          v-if="formList.showShareDesc"
        >
          <el-radio-group v-model="formList.showShare">
            <el-radio :label="0">不展示</el-radio>
            <el-radio :label="1">展示</el-radio>
          </el-radio-group>
        </el-form-item>
        <el-form-item :label="formList.infoKey">
          <el-input
            class="base-dialog-textarea"
            type="textarea"
            :rows="6"
            :placeholder="formList.textareaPlaceholder"
            v-model="formList.infoValue"
            :maxlength="formList.maxlength"
            show-word-limit
            resize="none"
          >
          </el-input>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="cancel('cancel')">取 消</el-button>
        <el-button type="primary" @click="submit('success')">确 定</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import { listContentBusinessForUserMan } from "@/api/man";

export default {
  name: "baseDialog",
  props: ["formData", "dialogShow", "isDisabled"],
  watch: {
    dialogShow(newValue) {
      this.dialogFormVisible = newValue;
    },
    formData(data) {},
  },
  created() {
    console.log(this.formData, "formData");
    if (this.formData) {
      console.log(this.formData);
      var { formList } = this.formData;
    }
    this.formList = formList || {};
    this.listContentBusinessForUserMan(); // 获取业务列表
  },
  data() {
    return {
      formList: {},
      dialogFormVisible: false,
      selectValue: "",
      businessList: [],
      disclosuretype: "1",
    };
  },

  methods: {
    cancel(type) {
      this.$emit("closeDialog", type);
      this.closeDialog();
    },
    submit(type) {
      this.$emit("closeDialog", type);
      this.closeDialog();
    },
    closeDialog() {
      this.$emit("dialogHandel", false);
    },
    changeSelectVal() {
      this.$emit("changeSelectVal", this.formList.business_ID);
    },
    async listContentBusinessForUserMan() {
      let res = await listContentBusinessForUserMan({
        tenantId: this.$commonJs.getTenantId(),
      }).then((res) => {
        this.businessList.splice(0, this.businessList.length);
        res?.contentBusinesses?.map((item) => {
          this.businessList.push({
            value: item.id,
            label: item.name,
          });
        });
      });
    },
  },
};
</script>

<style scoped lang="scss">
.base-dialog {
  position: relative;

  .red {
    color: red;
    position: absolute;
    left: 43px;
    top: 88px;
    font-size: 16px;
  }

  &-input {
    width: 276px;
  }

  &-select {
    width: 276px;
  }

  &-textarea {
    width: 276px;
    padding-top: 10px;
  }

  .el-dialog {
    width: 450px;
    position: relative;
    padding-bottom: 50px;
    font-size: 14px;
    color: #2c3443;
  }

  .el-dialog .el-form-item__label {
    width: 96px;
    font-weight: bolder;
  }

  .el-dialog .el-input__inner {
    height: 32px;
  }

  .el-dialog__body {
    padding: 30px 26px; //bugfix:字数统计遮挡文字
  }

  .el-dialog__header {
    background-color: #f7f8fb;
    height: 46px;
    display: flex;
    align-items: center;
  }

  .el-dialog__header .el-dialog__title {
    font-size: 16px;
    color: #333840;
    font-weight: bolder;
  }

  .el-dialog__header .el-dialog__headerbtn {
    position: absolute;
    top: 10px;
    right: 20px;
    padding: 0;
    border: none;
    outline: 0;
    cursor: pointer;
    font-size: 16px;
  }

  .el-dialog__footer {
    padding: 0;
    width: 100%;
    position: absolute;
    bottom: 29px;
    text-align: center;
  }

  .el-dialog__footer .el-button {
    width: 73px;
    height: 34px;
    line-height: 10px;
  }

  .el-dialog__footer .el-button--primary {
    background-color: dodgerblue;
    border-color: dodgerblue;
  }
}
</style>
